import React, { useEffect, useState } from 'react';
import {
	MenuList,
	MenuItem,
	Popper,
	Grow,
	ClickAwayListener,
	Paper,
	Fade
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
import { Bogle_Regular } from 'constants/constant';
import { useSelector } from 'react-redux';
import { deepClone } from 'helper/helper';

const { PURPLE, WHITE, LIGHT_PURPLE, FONT_COLOR } = colors;

const StyledMenuItem = withStyles({
	root: {
		fontFamily: Bogle_Regular,
		height: 48,
		color: FONT_COLOR,
		fontStyle: 'normal',
		'&$selected': {
			backgroundColor: `${WHITE}`,
			color: `${PURPLE}`,
			border: `1px solid ${PURPLE}`,
			'&:hover': {
				backgroundColor: LIGHT_PURPLE
			}
		}
	}
})(MenuItem);

function DashboardMenu(props) {
	// eslint-disable-next-line prettier/prettier
	const { anchorEl, handleClick, handleClose, selectedColumn, open, onKeyDown, selectedFilter } =
		props;

	const [set, setSet] = useState(null);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const { reportListFilterValues, reportTypeTabValue } = useSelector(
		(state) => state.dashboardReducer
	);

	useEffect(() => {
		const filterValues = deepClone(reportListFilterValues);
		cannedReportData?.forEach((item) => {
			// TODO: Adding "?" is a temporary hotfix, need to remove this after the actual fix has been done
			if (!filterValues?.Dataset?.includes(item.templateName)) {
				filterValues?.Dataset?.push(item.templateName);
			}
		});
		// For saved reports Dataset dropdown values comes from other store value
		let selectedColumnHeader = selectedColumn;
		if (selectedColumn === 'Dataset' && reportTypeTabValue === 1) {
			selectedColumnHeader = 'savedReportDataset';
		}
		if (selectedColumnHeader && filterValues && filterValues[selectedColumnHeader] !== set) {
			setSet(filterValues[selectedColumnHeader]);
		}
	}, [cannedReportData, selectedColumn, reportListFilterValues, reportTypeTabValue]);

	if (selectedColumn === null) {
		return null;
	}

	return (
		<Popper
			anchorEl={anchorEl}
			role={undefined}
			transition
			disablePortal
			style={{ zIndex: 1 }}
			placement={'right-end'}
			open={anchorEl?.name?.toLowerCase() === selectedColumn.toLowerCase()}>
			{({ TransitionProps, placement }) => (
				<Grow
					{...TransitionProps}
					style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
					<Paper style={{ transform: `translate(-15px, 80px)` }}>
						<ClickAwayListener onClickAway={handleClose}>
							<MenuList autoFocusItem={open} id="dashboard-menu-list-grow" onKeyDown={onKeyDown}>
								{set?.map((item) => {
									return (
										<StyledMenuItem
											transitioncomponent={Fade}
											key={item}
											onClick={(e) => handleClick(e)}
											selected={selectedFilter[selectedColumn]
												?.map((itm) => itm.toLowerCase())
												.includes(item.toLowerCase())}>
											{item}
										</StyledMenuItem>
									);
								})}
							</MenuList>
						</ClickAwayListener>
					</Paper>
				</Grow>
			)}
		</Popper>
	);
}

DashboardMenu.propTypes = {
	anchorEl: PropTypes.object,
	handleClick: PropTypes.func,
	handleClose: PropTypes.func,
	selectedColumn: PropTypes.string,
	// headers: PropTypes.array,
	open: PropTypes.bool,
	onKeyDown: PropTypes.func,
	selectedFilter: PropTypes.object
};

export default DashboardMenu;
